module.exports = ".host-container {\n  margin-top: 50px; }\n\n.row {\n  padding: 10px 0px 5px 10px; }\n\n.select:after {\n  top: 0.8rem; }\n\n.btn-outline,\n.btn-danger,\n.btn-success {\n  color: #4A12F0;\n  border-color: #4A12F0;\n  background-color: #FFFFFF;\n  font-weight: bold;\n  border-radius: 60px; }\n\n.btn:hover {\n  background-color: #311eaa;\n  color: #C9FF27; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorization/authorization.component.scss
// module id = ./src/app/authorization/authorization.component.scss
// module chunks = main